// extracted by mini-css-extract-plugin
module.exports = {"summary__stats":"G_cz","summary__stats__links":"G_cB","summary__stats__links__single":"G_cC"};